<div class="custom-delete-modal">
    <mat-card style="box-shadow: none; padding: 0; border-radius: 12px; margin: 0;">
        <mat-card-title style="font-size: 18px; font-weight: 600; color: #000; padding-bottom: 10px; border-bottom: 1px solid #999; margin-bottom: 15px; font-family: 'GothamBook', sans-serif;"> 
            {{ data.title ? data.title : 'Reactivate Confirmation' }}
        </mat-card-title>
        <mat-card-content style="padding: 0;">
            <p style="font-size: 15px; color: #333; margin-bottom: 15px; font-weight: 500; font-family: 'GothamBook', sans-serif;">
                {{ data.content ? data.content + ' ' + (data.id || '') : 'Are you sure you want to Reactivate?' }}
            </p>
            <!-- button wrapper -->
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxFlexFill>
                <button mat-dialog-close [mat-dialog-close]="data.id" cdkFocusInitial type="button" class="btn-reactivate-confirm">{{ reactivateText }}</button>
                <button mat-dialog-close type="button" class="btn-cancel-confirm">{{ cancelText }}</button>
            </div>
        </mat-card-content>
    </mat-card>
</div>
